import React, { useEffect, useState } from 'react'
// import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';
import Barcode from "react-barcode";
// import SearchIcon from '@mui/icons-material/Search';
import ScienceIcon from '@mui/icons-material/Science';
import axios from 'axios';
// import Modal from 'react-bootstrap/Modal';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';

function OnAssignLab({ serverUrl, user, titleOfPage, globalUserId, globalToken   }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();


    // const [newBarCodeView, setNewBarCodeView] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [recordsData, setRecordsData] = useState([]);
    const [currentData, setCurrentsData] = useState([]);
    const [validity, setValidity] = useState("10");
    const [barcodeNumber, setBarcodeNumber] = useState("");
    const [allLabs, setAllLabs] = useState([]);
    const [selectedBox, setSelectedBox] = useState([]);

    const [yearFilter, setYearFilter] = useState("all")
    const [labFilter, setLabFilter] = useState("all")


    const handleSelectAll = () => {
        const allButtons = document.querySelectorAll(".barCodeSelector");
        if (checkedAll) {
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = false
            }
            setCheckedAll(false)
            setSelectedBox([])

            // console.log(selectedBox)
        } else {
            let allRest = [];
            for (let i = 0; i < allButtons.length; i++) {
                allButtons[i].checked = true
                allRest.push(allButtons[i].id)
            }

            setSelectedBox(allRest)
            setCheckedAll(true)

            // console.log(allRest)
        }
    }



    const getAllBarcodes = async () => {
        const query = { code: "all" }

        const getData = await axios.post(serverUrl + "/barcodes/find", query)
        if (getData.status == 200) {
            // console.log(getData.data)
            setRecordsData(getData.data)
            setCurrentsData(getData.data)
        } else {
            console.log(getData.data)
        }
    }

    const resetAllFields = () => {
        setRecordsData([]);
        setValidity("");
        setBarcodeNumber("");
        setSelectedBox([])
    }

    const updateSelectedValues = (code) => {
        let allRest = selectedBox;

        if (allRest.includes(code)) {
            allRest = allRest.filter((oldcode) => { return oldcode !== code })
            // console.log(allRest)
        } else {
            allRest.push(code)
            // console.log(allRest)
        }
        setSelectedBox(allRest);
    }


    const markStateAs = async (As) => {
        // console.log(selectedBox)
        const allData = { "selectedCodes": selectedBox, "markAs": As };

        const markNow = await axios.post(serverUrl + "/barcodes/markStatusAs", allData)

        if (markNow.status == 200) {
            getAllBarcodes()
            // console.log(markNow.data)
        } else {
            console.log(markNow.data)
        }
    }

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }

    const getAllLabs = async () => {
        const getAllLabs = await axios.post(serverUrl + "/labs/get", { code: "all" });
        if (getAllLabs.status == 200) {
            setAllLabs(getAllLabs.data);
        } else {
            console.log("No Data Found");
        }
    }

    useEffect(() => {
        setSelectedBox([])
        getAllBarcodes()
        getAllLabs()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3 d-flex gap-3 justify-content-between  flex-wrap'>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setCurrentsData(recordsData.filter((product) => { return product.name?.includes(e.target.value) })) } else { setCurrentsData(recordsData) } }}>
                                    <option value="all">All</option>
                                    {
                                        allLabs.map((data, key) => {
                                            return <option key={key} value={data.name}>{data.name}</option>
                                        })
                                    }
                                </select>
                            </div>
                            <button className="btn btn-secondary px-4 py-2 rounded-pill fw-bold">Handover</button>
                        </div>
                        <div className='d-flex gap-5 flex-wrap'>
                            <div className='d-flex gap-2 align-items-center upperMoonsSearch'>
                                <span className='fw-bold'>
                                    <ScienceIcon style={{ width: "1.7em", height: "1.7em" }} />
                                </span>
                                <select name="" id="" className='customFieldForDence' onChange={(e) => { if (e.target.value != "all") { setYearFilter(e.target.value) } else { setYearFilter("all") } }}>
                                    <option value="all">All</option>
                                    <option value="10">10 Years</option>
                                    <option value="12">12 Years</option>
                                    <option value="15">15 Years</option>
                                    <option value="20">20 Years</option>
                                </select>
                            </div>
                            <CSVDownloader
                                type={Type.Button}
                                filename={'OnAssignLab'}
                                bom={true}
                                config={{
                                    delimiter: ',',
                                }}
                                className="btn btn-success px-4 py-2 rounded-pill fw-bold"
                                data={
                                    jsonToCSV(currentData.filter((data) => { return data.status === "Assigned" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }))
                                }
                            >
                                Export to Excel
                            </CSVDownloader>
                        </div>
                    </div>
                    <div className="themeTextColor fs-5 my-3 fw-bold d-flex gap-1">
                        <span>
                            Total Records:
                        </span>
                        {
                            currentData.length > 0 ?
                                currentData.filter((data) => { return data.status === "Assigned" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                    currentData.filter((data) => { return data.status === "Assigned" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length
                                    :
                                    "0"
                                :
                                "0"
                        }
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='ssticky-top'>
                                    <th valign='middle'><input type="checkbox" className='form-check-input' onChange={(e) => { handleSelectAll(); }} /></th>
                                    <th valign='middle' width="1%"><span className='text-nowrap'>Barcode Image</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Barcode No.</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Generated Date</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Validity Year</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Assigned To</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Status</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    currentData.length > 0 ?
                                        currentData.filter((data) => { return data.status === "Assigned" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).length > 0 ?
                                            currentData.filter((data) => { return data.status === "Assigned" && (data.validityYear?.toString().includes(yearFilter) || yearFilter == "all") }).map((data, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td valign='middle'>
                                                            <input type="checkbox" id={data.code} className='form-check-input barCodeSelector' onChange={(e) => { updateSelectedValues(data.code) }} />
                                                        </td>
                                                        <td valign='middle'>
                                                            <Barcode
                                                                value={data.code}
                                                                width={2}
                                                                height={60}
                                                                format="CODE39"
                                                                displayValue={true}
                                                                fontOptions=""
                                                                font="monospace"
                                                                // textAlign="center"
                                                                textPosition="bottom"
                                                                // textMargin={2}
                                                                fontSize={35}
                                                                background="#ffffff"
                                                                lineColor="#000000"
                                                                // margin={10}
                                                                // marginTop=""
                                                                // marginBottom=""
                                                                // marginLeft=""
                                                                // marginRight=""
                                                                id=""
                                                                className="barcodeImages"

                                                            />
                                                            {/* <QRCode
                                                                size={256}
                                                                // bgColor=""
                                                                fgColor="#D87339"
                                                                level="M"
                                                                title={uuidv4()}
                                                                style={{ height: "auto", maxWidth: "60px", width: "100%" }}
                                                                value={uuidv4()}
                                                                viewBox={`0 0 256 256`}
                                                            /> */}
                                                        </td>
                                                        <td valign='middle'>{data.code}</td>
                                                        <td valign='middle'>
                                                            {data.verificationCode}
                                                        </td>
                                                        <td valign='middle'>{data.validityYear}</td>
                                                        <td valign='middle'>{data.usedTo}</td>

                                                        <td valign='middle'>{data.status}</td>
                                                    </tr>
                                                )
                                            })
                                            :
                                            <tr>
                                                <td valign='middle' colSpan={7}>
                                                    <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                        No Data
                                                    </div>
                                                </td>
                                            </tr>
                                        :
                                        <tr>
                                            <td valign='middle' colSpan={7}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    No Data
                                                </div>
                                            </td>
                                        </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div >
        </>
    )
}

export default OnAssignLab